var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-image-lightbox',{ref:"products",attrs:{"media":_vm.media,"show-thumbs":false,"show-caption":true,"show-light-box":false}})}
var staticRenderFns = []

export { render, staticRenderFns }